import { render } from "./catalog-page.vue?vue&type=template&id=5cb47866"
import script from "./catalog-page.vue?vue&type=script&lang=js"
export * from "./catalog-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__